import { render, staticRenderFns } from "./CabinsGuests.vue?vue&type=template&id=7d4db2bf&"
import script from "./CabinsGuests.vue?vue&type=script&setup=true&lang=js&"
export * from "./CabinsGuests.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports